import React from 'react';

const SVG = ({ opacity = 1, width = '100%', viewBox = '0 0 214 166' }) => (
  <svg width={width} height={(width * 166) / 214} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke="silver">
      <rect width="214" height="166" fill="none" stroke="none" />
      <rect x="131" y="35" width="48" height="48" fill="rgb(255,255,100)" />
      <rect x="35" y="83" width="48" height="48" fill="rgb(255,100,100)" />
      <path d="M0,35 H214 M0,83 H214 M0,131 H1214 M35,0 V166 M83,0 V166 M131,0 V166 M179,0 V166" />
      <g opacity={opacity}>
        <rect x="35" y="35" width="96" height="48" fill="rgb(100,100,255)" />
        <rect x="83" y="83" width="96" height="48" fill="rgb(100,255,100)" />
        <path d="M83,36 v48 h48 v48" stroke="darkred" strokeWidth="3" fill="none" />
        <circle cx="59" cy="59" r="7" fill="none" stroke="black" strokeWidth="4" />
        <circle cx="107" cy="59" r="7" fill="none" stroke="black" strokeWidth="4" />
        <rect x="100" y="100" width="14" height="14" stroke="black" strokeWidth="4" fill="none" />
        <rect x="148" y="100" width="14" height="14" stroke="black" strokeWidth="4" fill="none" />
      </g>
      <rect x="58" y="98" width="4" height="18" fill="black" stroke="none" />
      <rect x="144" y="59" width="18" height="4" fill="black" stroke="none" />
    </g>
  </svg>
);

export default SVG;
